<template>
	<fieldset id="fs-custom-load" class="pt-3 pb-3">
		<div class="container">
			<!-- Toggle to enable/disable custom load -->
			<div class="row justify-content-start align-items-center mb-3">
				<button
					type="button"
					:class="['js-btn-toggle', isEnabled && 'toggled']"
					@click.prevent="handleToggle"
					ref="button"
				>
					<i class="toggle-knob"></i>
					<span class="label">Use Custom Load Shape</span>
				</button>
			</div>

			<!-- Expanded section when enabled -->
			<div v-if="isEnabled" class="custom-load-section">
				<h4 class="section-title">Custom Hot Water Load</h4>

				<div class="mode-selector">
					<label class="radio-option">
						<input
							type="radio"
							value="addCL"
							v-model="formData.customLoadMethod"
						>
						<span>Add Custom Load to Multifamily Load</span>
					</label>

					<label class="radio-option">
						<input
							type="radio"
							value="onlyCL"
							v-model="formData.customLoadMethod"
						>
						<span>Calculate only Custom Load (disable Multifamily)</span>
					</label>
				</div>

				<div class="hourly-inputs-container">
					<p class="inputs-label">Gallons per hour for the peak day</p>

					<div class="hourly-row">
						<HourlyInput
							v-for="hour in amHours"
							:key="hour"
							:hour="hour"
						/>
					</div>

					<div class="hourly-row">
						<HourlyInput
							v-for="hour in pmHours"
							:key="hour"
							:hour="hour"
						/>
					</div>

					<p class="warning-text">
						<i class="fa-solid fa-triangle-exclamation"></i>
						This is an expert-level feature. Custom load values override or add to standard building type calculations.
					</p>
				</div>
			</div>
		</div>
	</fieldset>
</template>

<script>
import formData from '@/components/Sizer/form-data-store'
import HourlyInput from './components/HourlyInput.vue'

export default {
	name: 'CustomLoadInputs',

	components: {
		HourlyInput,
	},

	data: () => ({
		formData,
		amHours: [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11],
		pmHours: [12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23],
	}),

	computed: {
		isEnabled () {
			return this.formData.customLoadMethod !== 'ignCL'
		},
	},

	methods: {
		handleToggle () {
			const { $refs: { button } } = this

			if (this.formData.customLoadMethod === 'ignCL') {
				// Enable custom load - default to "add" mode
				this.formData.customLoadMethod = 'addCL'
			} else {
				// Disable custom load
				this.formData.customLoadMethod = 'ignCL'
			}

			button.blur()
		},
	},
}
</script>

<style scoped>
.custom-load-section {
	background: #f8f9fa;
	border: 1px solid #dee2e6;
	border-radius: 8px;
	padding: 20px;
	margin-top: 10px;
}

.section-title {
	margin: 0 0 15px 0;
	font-size: 1.1rem;
	font-weight: 600;
	color: #333;
}

.mode-selector {
	display: flex;
	flex-direction: column;
	gap: 10px;
	margin-bottom: 20px;
}

.radio-option {
	display: flex;
	align-items: center;
	gap: 8px;
	cursor: pointer;
	font-size: 0.95rem;
}

.radio-option input[type="radio"] {
	margin: 0;
	cursor: pointer;
}

.hourly-inputs-container {
	border-top: 1px solid #dee2e6;
	padding-top: 20px;
}

.inputs-label {
	font-weight: 600;
	margin-bottom: 15px;
	color: #555;
}

.hourly-row {
	display: flex;
	flex-wrap: wrap;
	gap: 8px;
	margin-bottom: 15px;
	justify-content: flex-start;
}

.warning-text {
	font-size: 0.85rem;
	color: #856404;
	background: #fff3cd;
	padding: 10px 15px;
	border-radius: 4px;
	margin-top: 15px;
	margin-bottom: 0;
}

.warning-text i {
	margin-right: 8px;
}
</style>
